import ExploreIcon from "@mui/icons-material/Explore";
import TrackChangesIcon from "@mui/icons-material/TrackChanges";
import { motion } from "framer-motion";
import {
  company,
  values,
} from "../../../../utils/siteContent";
import { getIcon } from "../../../../utils/iconMap";
import { revealProps } from "../../../../utils/motion";
import Reveal from "../../../commons/reveal/reveal";
import SectionHeading from "../../../commons/sectionHeading/sectionHeading";
import { StyledAbout } from "../../../styled/about";
import { StyledLayout } from "../../../styled/layout";

const MotionMission = motion(StyledAbout.Mission);
const MotionValueCard = motion(StyledAbout.ValueCard);
const MotionCertCard = motion(StyledAbout.CertCard);

const About = () => (
  <StyledLayout.Section id="nosotros">
    <StyledLayout.Container>
      <StyledAbout.Top>
        <Reveal>
          <StyledAbout.Intro>
            <SectionHeading
              tag="Nosotros"
              title={
                <>
                  Socios estratégicos en tu{" "}
                  <StyledLayout.GradientText>
                    transformación digital
                  </StyledLayout.GradientText>
                </>
              }
              lead={`Desde ${company.founded} entregamos soluciones informáticas que ponen la tecnología al servicio de las organizaciones, mediante productos y servicios de última generación.`}
            />
          </StyledAbout.Intro>
        </Reveal>

        <StyledAbout.Cards>
          <MotionMission {...revealProps(0.05)}>
            <div className="mi-icon">
              <TrackChangesIcon />
            </div>
            <h3>Nuestra misión</h3>
            <p>
              Poner la tecnología al servicio de las organizaciones con productos
              y servicios de última generación que generen valor real.
            </p>
          </MotionMission>
          <MotionMission alt {...revealProps(0.12)}>
            <div className="mi-icon">
              <ExploreIcon />
            </div>
            <h3>Nuestro desafío</h3>
            <p>
              Constituirnos como socios estratégicos de nuestros clientes, sobre
              la base de la calidad de nuestros productos y servicios.
            </p>
          </MotionMission>
        </StyledAbout.Cards>
      </StyledAbout.Top>

      {/* ADN / valores */}
      <Reveal>
        <StyledAbout.ValuesHead>
          <h3>
            El ADN de <StyledLayout.GradientText>Access</StyledLayout.GradientText>
          </h3>
          <p>Los principios que guían cada decisión y cada línea de código.</p>
        </StyledAbout.ValuesHead>
      </Reveal>

      <StyledAbout.Values>
        {values.map((v, i) => {
          const Icon = getIcon(v.icon);
          return (
            <MotionValueCard key={v.title} {...revealProps(i * 0.06)}>
              <div className="value-icon">
                <Icon />
              </div>
              <h4>{v.title}</h4>
              <p>{v.text}</p>
            </MotionValueCard>
          );
        })}
      </StyledAbout.Values>

    </StyledLayout.Container>
  </StyledLayout.Section>
);

export default About;
